import createSvgIcon from '../Utils/CreateSvgIcon';

export const ArrowDown = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M13.0004 17.1712L12.9995 3.00049L10.9995 3.00061L11.0004 17.1729L4.22134 10.3939L2.80713 11.8081L11.9995 21.0005L21.1929 11.8071L19.7787 10.3929L13.0004 17.1712Z"
    fillRule="evenodd"
  />,
  'ArrowDown',
);
